module.exports = "<div class=\"text-align-right\"\r\n    ng-class=\"{'text-success': $ctrl.coincide === true, 'text-error': $ctrl.coincide === false, 'text-light': $ctrl.coincide === null}\"\r\n    style=\"width:80px\">\r\n  <span class=\"--text-bold --text-small\">{{::$ctrl.validacion}}</span>\r\n  <i class=\"fa fa-fw\"\r\n      ng-class=\"{'fa-check': $ctrl.coincide === true, 'fa-times': $ctrl.coincide === false}\"></i>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/recursoshumanos/components/visorlotes/lote/validacion/template.html
// module id = 770
// module chunks = 0